import {registerAPIService} from './APIServicesRegistry';
import ConfigurationAPIService from './ConfigurationAPIService';

export default class ConfigurationReadOnlyApiService extends ConfigurationAPIService {
    constructor() {
        super('ConfigurationReadOnly')
    }

    getDocumentationModalContent(data) {
        return this.post('GetDocumentationModalContent', data)
    }

    generateDocumentation(data) {
        return this.post('GenerateDocument', data, 'blob')
    }

    generateXlsDocumentation(data) {
        return this.post('GenerateXlsDocument', data, 'blob')
    }

    exportModuleXls(model) {
        return this.post('ExportModuleXls', model, 'blob');
    }
}

registerAPIService(ConfigurationReadOnlyApiService)